import { useMutation, useQueryClient } from 'react-query';

import { assetsApi } from 'src/Services/API';
import { UpdateAssetDto } from 'src/Services/API/generated';

export const useUpdateAsset = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ assetId, data }: { assetId: string; data: UpdateAssetDto }) =>
      assetsApi.assetsControllerUpdate(assetId, data),
    {
      onSuccess: (_, { assetId }) => {
        queryClient.invalidateQueries(['asset', assetId]);
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
        queryClient.invalidateQueries(['fetch-assets']);
      },
    }
  );
};
